module.exports = __webpack_public_path__ + "d6ad5e74616939324a508e12017a22ea.svg";